export type RenderProofExperience = 'current_experience' | 'test_experience';

// Deterministic hash bucketing on the user id: same id always maps to the same
// arm, with no persistence or randomness. The integer mix avoids the even/odd
// correlation a bare `userId % 2` would give sequential ids.
function bucketOf(userId: number): number {
  let hash = userId | 0;
  hash = Math.imul(hash ^ (hash >>> 16), 0x45d9f3b);
  hash = Math.imul(hash ^ (hash >>> 16), 0x45d9f3b);
  hash ^= hash >>> 16;
  return Math.abs(hash) % 2;
}

export function resolveRenderProofExperience(
  userId: number,
): RenderProofExperience {
  return bucketOf(userId) === 0 ? 'current_experience' : 'test_experience';
}
